import { taggedTemplateLiteral as _taggedTemplateLiteral, objectSpread2 as _objectSpread2 } from '../../../_virtual/_rollupPluginBabelHelpers.js';
import propTypes from '../../../node_modules/prop-types/index.js';
import { styled, TableRow as TableRow$2 } from '@mui/material';
import classnames from '../../../node_modules/classnames/index.js';
import React, { useCallback } from 'react';
import TableContext from '../TableContext.js';
import { createComponentSlot } from '../../../modules/styling/theme.js';

var _templateObject, _templateObject2;
var componentRow = createComponentSlot({
  name: "CinTable",
  slot: "Row"
});

var TableRowBase = function TableRowBase(_ref) {
  var data = _ref.data,
      dataKey = _ref.dataKey,
      item = _ref.item,
      itemKey = _ref.itemKey,
      itemIndex = _ref.itemIndex,
      expanded = _ref.expanded,
      selectable = _ref.selectable,
      headerExists = _ref.headerExists,
      footerExists = _ref.footerExists,
      onClick = _ref.onClick,
      onExpand = _ref.onExpand,
      onCollapse = _ref.onCollapse,
      children = _ref.children,
      renderRowLink = _ref.renderRowLink,
      _ref$getRowClassName = _ref.getRowClassName,
      getRowClassName = _ref$getRowClassName === void 0 ? function () {
    return null;
  } : _ref$getRowClassName;
  var onRowClick = useCallback(function () {
    if (onClick) onClick(item, itemKey);
  }, [item, itemKey, onClick]);
  var onRowExpand = useCallback(function () {
    if (onExpand) onExpand(itemKey);
  }, [itemKey, onExpand]);
  var onRowCollapse = useCallback(function () {
    if (onCollapse) onCollapse(itemKey);
  }, [itemKey, onCollapse]);
  var rowState = {
    itemKey: itemKey,
    itemIndex: itemIndex,
    expanded: expanded
  };
  var rowEvents = {
    onExpand: onRowExpand,
    onCollapse: onRowCollapse
  };
  var tableContext = {
    data: data,
    dataKey: dataKey,
    item: item,
    itemKey: itemKey,
    itemIndex: itemIndex,
    expanded: expanded,
    headerExists: headerExists,
    footerExists: footerExists,
    onClick: onClick,
    onExpand: onRowExpand,
    onCollapse: onRowCollapse,
    renderRowLink: renderRowLink
  };
  return /*#__PURE__*/React.createElement(HoverableMTableRow, {
    onClick: onRowClick,
    className: classnames(componentRow.className, getRowClassName(item), item.className, {
      expanded: expanded
    }),
    hover: selectable
  }, /*#__PURE__*/React.createElement(TableContext.Provider, {
    value: tableContext
  }, typeof children === "function" ? children(item, rowState, rowEvents) : children));
};

TableRowBase.propTypes = {
  item: propTypes.any.isRequired,
  itemKey: propTypes.any.isRequired,
  itemIndex: propTypes.number.isRequired,
  data: propTypes.arrayOf(propTypes.any).isRequired,
  dataKey: propTypes.string.isRequired,
  onClick: propTypes.func,
  onExpand: propTypes.func,
  onCollapse: propTypes.func,
  expanded: propTypes.bool.isRequired,
  selectable: propTypes.bool.isRequired,
  headerExists: propTypes.bool.isRequired,
  footerExists: propTypes.bool.isRequired,
  children: propTypes.oneOfType([propTypes.node, propTypes.func]),
  renderRowLink: propTypes.func,
  getRowClassName: propTypes.func
};
var HoverableMTableRow = styled(TableRow$2)(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  td.hoverable > *,\n  td.hoverable > .CinTableColumn-content > * {\n    transition: opacity 0.25s;\n    opacity: 0;\n  }\n\n  &:hover td.hoverable > *,\n  &:hover td.hoverable > .CinTableColumn-content > *,\n  td.hoverable > .CinTableMenu-root.open,\n  td.hoverable > .CinTableColumn-content > .CinTableMenu-root.open,\n  td.hoverable > .CinTableColumn-content {\n    opacity: 100;\n  }\n"])));
/**
 * Renders a row for a table data item
 */

var TableRow = styled(TableRowBase, _objectSpread2(_objectSpread2({}, componentRow.styledOptions), {}, {
  skipSx: true,
  skipVariantsResolver: true
}))(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral([""])));
var TableRow$1 = TableRow;

export { TableRow$1 as default };
